// extracted by mini-css-extract-plugin
module.exports = {"text":"FormInputError_text__1N7vj"};